export const LOCALE_CONFIG: { [key in SupportedLanguage]: string } = {
  en: 'us',
  es: 'es',
};

export type SupportedLanguage = 'en' | 'es';
